/* Vantorclub: progressively enhanced navigation and native-form sticky purchase. */
(() => {
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-v-disclosure][open]').forEach((details) => {
      if (!details.contains(event.target) || event.target.closest('a')) details.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = [...document.querySelectorAll('[data-v-disclosure][open]')];
    const active = open.find((details) => details.contains(document.activeElement)) || open[0];
    open.forEach((details) => { details.open = false; });
    active?.querySelector('summary')?.focus();
  });
  document.addEventListener('toggle', (event) => {
    if (!event.target.matches?.('[data-v-disclosure]') || !event.target.open) return;
    document.querySelectorAll('[data-v-disclosure][open]').forEach((details) => {
      if (details !== event.target) details.open = false;
    });
  }, true);
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('[data-v-header]')) document.querySelector('cart-drawer')?.setHeaderCartIconAccessibility?.();
  });
  if (customElements.get('vantor-sticky-buy')) return;
  customElements.define('vantor-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      this.product = this.closest('product-info');
      this.action = this.querySelector('[data-v-sticky-submit]');
      this.price = this.querySelector('[data-v-sticky-price]');
      this.errorLabel = this.querySelector('[data-v-sticky-error]');
      if (!this.product || !this.action) return;
      this.abort = new AbortController();
      this.action.addEventListener('click', () => {
        const source = this.sourceButton;
        if (!source || source.disabled || source.getAttribute('aria-disabled') === 'true') return;
        source.form?.requestSubmit(source);
      }, { signal: this.abort.signal });
      this.product.addEventListener('change', () => this.sync(), { signal: this.abort.signal });
      this.mutations = new MutationObserver(() => this.sync());
      const info = this.product.querySelector('[id^="ProductInfo-"]');
      if (info) this.mutations.observe(info, { subtree: true, childList: true, attributes: true, characterData: true });
      this.intersections = new IntersectionObserver(([entry]) => {
        this.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        this.sync();
      });
      if (this.sourceButton) this.intersections.observe(this.sourceButton);
      this.sync();
    }
    get sourceButton() { return this.product?.querySelector('[id^="ProductSubmitButton-"]'); }
    sync() {
      const source = this.sourceButton;
      if (!source) { this.hidden = true; return; }
      this.action.disabled = source.disabled || source.getAttribute('aria-disabled') === 'true';
      this.action.textContent = source.classList.contains('loading') ? 'Añadiendo…' : source.querySelector('span')?.textContent.trim() || 'Añadir al carrito';
      const visiblePrice = this.product.querySelector('.price--on-sale .price-item--sale') || this.product.querySelector('.price__regular .price-item--regular');
      this.price.textContent = visiblePrice?.textContent.trim() || '';
      const error = this.product.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message');
      if (this.errorLabel) { this.errorLabel.textContent = error?.textContent.trim() || ''; this.errorLabel.hidden = !this.errorLabel.textContent; }
    }
    disconnectedCallback() { this.abort?.abort(); this.mutations?.disconnect(); this.intersections?.disconnect(); }
  });
})();
